"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "giustenice": {
    "c2cd4525": [{
      "hkey": "339287b0",
      "slug": "giustenice",
      "name": "Giustenice",
      "primary": true,
      "skipSearch": false
    }],
    "san-lorenzo": [{
      "hkey": "339287b0",
      "slug": "giustenice",
      "name": "Giustenice",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "82998de6": [{
      "hkey": "339287b0",
      "slug": "giustenice",
      "name": "Giustenice",
      "primary": true,
      "skipSearch": false
    }],
    "san-michele": [{
      "hkey": "339287b0",
      "slug": "giustenice",
      "name": "Giustenice",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;